// Baruch College's bachelor's programs (#2739). Read on 2026-10-01 from
// Baruch's official undergraduate catalog
// (baruch-undergraduate.catalog.cuny.edu, CUNY's catalog host), Programs: all
// 124 entries, read in a browser page by page. The list gives a department but
// no school for each program, so this is one A to Z group. Names and degree
// abbreviations are the catalog's (BA, BS, BBA). Left out: minors and the one
// certificate (Psychology).
const majors = {
    "slug": "cuny-bernard-m-baruch-college",
    "read": "2026-10-01",
    "intro": "Every bachelor's program in Baruch College's official undergraduate catalog, A to Z, with the degree it leads to. Minors and certificates are left out.",
    "groups": [
        {
            "name": "Bachelor's programs, A to Z",
            "source": {
                "label": "Baruch College Undergraduate Catalog, Programs",
                "url": "https://baruch-undergraduate.catalog.cuny.edu/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "BA"
                },
                {
                    "name": "Applied Data Science and Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Black and Latino Studies",
                    "degree": "BA"
                },
                {
                    "name": "Business Communications",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BBA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Financial Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Industrial and Organizational Psychology",
                    "degree": "BBA"
                },
                {
                    "name": "International Business",
                    "degree": "BBA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Arts - Ad Hoc",
                    "degree": "BA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing Management",
                    "degree": "BBA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Affairs",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Statistics and Quantitative Modeling",
                    "degree": "BBA"
                }
            ]
        }
    ]
};

export default majors;
